'use client';

import { useEntrySearchStore } from '@liquorice/next-search';
import Grid from '../ui/Grid';
import ArticleResult from './ArticleResult';

export default function ArticleResults() {
  const { results } = useEntrySearchStore((s) => s);

  return (
    <Grid rowGutter cx={{ rowGap: { xs: 'xl', lg: '3xl' } }}>
      {results.map((result, index) => (
        <Grid.Col key={index} lg={4}>
          <ArticleResult id={result.id} />
        </Grid.Col>
      ))}
    </Grid>
  );
}
